module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-shadow-4.e5b5c8a0.png";